import { sendLanguage } from "./WebServices";

export const PENDING_KEY = "langSyncPending";

const RETRY_DELAYS_MS = [500, 1500, 4000]; // 3 attempts, increasing backoff

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

/**
 * POST the user's language preference to the backend with retry + pending flag.
 * - On success: clears localStorage[PENDING_KEY].
 * - On failure after all retries: sets localStorage[PENDING_KEY] = lang so the
 *   startup re-sync hook can finish the job next time the app opens.
 * Never throws; never shows an error to the user.
 */
export const sendLanguageWithRetry = async (userId, lang) => {
  if (!userId || !lang) return;

  for (let attempt = 0; attempt <= RETRY_DELAYS_MS.length; attempt++) {
    try {
      await sendLanguage(userId, lang);
      // Confirmed success — clear any previously queued pending sync.
      try { localStorage.removeItem(PENDING_KEY); } catch (_) {}
      return;
    } catch (err) {
      if (attempt < RETRY_DELAYS_MS.length) {
        await sleep(RETRY_DELAYS_MS[attempt]);
      } else {
        // All retries exhausted — queue for startup re-sync.
        try { localStorage.setItem(PENDING_KEY, lang); } catch (_) {}
        console.warn("Language sync failed after retries; will retry on next app load.", err);
      }
    }
  }
};
